module.exports = __webpack_public_path__ + "42f04acca076794b45d564b8a3e85ebc.pdf";